const n = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "label:not([inert])", "[tabindex]:not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])", '[focusable]:not([focusable="false"])'], t = ':not([tabindex="-1"])', e = n.join(`${t}, `) + t, o = n.join(", ");
export {
  o as f,
  e as u
};
//# sourceMappingURL=focusable-selectors-BazEJmRZ.js.map
